// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dHg_","name":"Header_name__eQVr1","birthday":"Header_birthday__3-3hz","skeleton":"Header_skeleton__2_jZ1"};